"use strict";
var import_vitest = require("vitest");
var import_getPathFromState = require("../getPathFromState");
var import_getStateFromPath = require("../getStateFromPath");
(0, import_vitest.test)("converts state to path string", function() {
  var state = {
    routes: [
      {
        name: "foo",
        state: {
          index: 1,
          routes: [
            {
              name: "boo"
            },
            {
              name: "bar",
              params: {
                fruit: "apple"
              },
              state: {
                routes: [
                  {
                    name: "baz qux",
                    params: {
                      author: "jane",
                      valid: true
                    }
                  }
                ]
              }
            }
          ]
        }
      }
    ]
  };
  var path = "/foo/bar/baz%20qux?author=jane&valid=true";
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state)).toBe(path);
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path))).toBe(path);
});
(0, import_vitest.test)("converts state to path string with config", function() {
  var path = "/few/bar/sweet/apple/baz/jane?id=x10&valid=true";
  var config = {
    screens: {
      Foo: {
        path: "few",
        screens: {
          Bar: {
            path: "bar/:type/:fruit",
            screens: {
              Baz: {
                path: "baz/:author",
                parse: {
                  author: function(author) {
                    return author.replace(/^\w/, function(c) {
                      return c.toUpperCase();
                    });
                  },
                  id: function(id) {
                    return Number(id.replace(/^x/, ""));
                  },
                  valid: Boolean
                },
                stringify: {
                  author: function(author) {
                    return author.toLowerCase();
                  },
                  id: function(id) {
                    return `x${id}`;
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  var state = {
    routes: [
      {
        name: "Foo",
        state: {
          index: 1,
          routes: [
            {
              name: "boo"
            },
            {
              name: "Bar",
              params: {
                fruit: "apple",
                type: "sweet",
                avaliable: false
              },
              state: {
                routes: [
                  {
                    name: "Baz",
                    params: {
                      author: "Jane",
                      id: 10,
                      valid: true
                    }
                  }
                ]
              }
            }
          ]
        }
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state, config)).toBe(path);
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path, config), config)).toBe(path);
});
(0, import_vitest.test)("prepends trailing slash to path", function() {
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)({
    routes: [
      {
        name: "foo",
        state: {
          routes: [
            {
              name: "bar"
            }
          ]
        }
      }
    ]
  })).toBe("/foo/bar");
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)({
    routes: [
      {
        name: "foo",
        state: {
          routes: [
            {
              name: "bar",
              path: "foo/bar"
            }
          ]
        }
      }
    ]
  })).toBe("/foo/bar");
});
(0, import_vitest.test)("handles route without param", function() {
  var path = "/foo/bar";
  var state = {
    routes: [
      {
        name: "foo",
        state: {
          routes: [
            {
              name: "bar"
            }
          ]
        }
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state)).toBe(path);
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path))).toBe(path);
});
(0, import_vitest.test)("doesn't add query param for empty params", function() {
  var path = "/foo";
  var state = {
    routes: [
      {
        name: "foo",
        params: {}
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state)).toBe(path);
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path))).toBe(path);
});
(0, import_vitest.test)("handles state with config with nested screens", function() {
  var path = "/foo/foe/bar/sweet/apple/baz/jane?answer=42&count=10&valid=true";
  var config = {
    screens: {
      Foo: {
        path: "foo",
        screens: {
          Foe: {
            path: "foe",
            screens: {
              Bar: {
                path: "bar/:type/:fruit",
                screens: {
                  Baz: {
                    path: "baz/:author",
                    parse: {
                      author: function(author) {
                        return author.replace(/^\w/, function(c) {
                          return c.toUpperCase();
                        });
                      },
                      count: Number,
                      valid: Boolean
                    },
                    stringify: {
                      author: function(author) {
                        return author.toLowerCase();
                      },
                      id: function(id) {
                        return `x${id}`;
                      },
                      unknown: function(_) {
                        return "x";
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  var state = {
    routes: [
      {
        name: "Foo",
        state: {
          routes: [
            {
              name: "Foe",
              state: {
                routes: [
                  {
                    name: "Bar",
                    params: {
                      fruit: "apple",
                      type: "sweet"
                    },
                    state: {
                      routes: [
                        {
                          name: "Baz",
                          params: {
                            answer: "42",
                            author: "Jane",
                            count: "10",
                            valid: true
                          }
                        }
                      ]
                    }
                  }
                ]
              }
            }
          ]
        }
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state, config)).toBe(path);
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path, config), config)).toBe(path);
});
(0, import_vitest.test)("handles state with config with nested screens and exact", function() {
  var path = "/foe/bar/sweet/apple/baz/jane?answer=42&count=10&valid=true";
  var config = {
    screens: {
      Foo: {
        path: "foo",
        screens: {
          Foe: {
            path: "foe",
            exact: true,
            screens: {
              Bar: {
                path: "bar/:type/:fruit",
                screens: {
                  Baz: {
                    path: "baz/:author",
                    parse: {
                      author: function(author) {
                        return author.replace(/^\w/, function(c) {
                          return c.toUpperCase();
                        });
                      },
                      count: Number,
                      valid: Boolean
                    },
                    stringify: {
                      author: function(author) {
                        return author.toLowerCase();
                      },
                      id: function(id) {
                        return `x${id}`;
                      },
                      unknown: function(_) {
                        return "x";
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  var state = {
    routes: [
      {
        name: "Foo",
        state: {
          routes: [
            {
              name: "Foe",
              state: {
                routes: [
                  {
                    name: "Bar",
                    params: {
                      fruit: "apple",
                      type: "sweet"
                    },
                    state: {
                      routes: [
                        {
                          name: "Baz",
                          params: {
                            answer: "42",
                            author: "Jane",
                            count: "10",
                            valid: true
                          }
                        }
                      ]
                    }
                  }
                ]
              }
            }
          ]
        }
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state, config)).toBe(path);
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path, config), config)).toBe(path);
});
(0, import_vitest.test)("handles state with config with nested screens and unused configs", function() {
  var path = "/foo/foe/baz/jane?answer=42&count=10&valid=true";
  var config = {
    screens: {
      Foo: {
        path: "foo",
        screens: {
          Foe: {
            path: "foe",
            screens: {
              Baz: {
                path: "baz/:author",
                parse: {
                  author: function(author) {
                    return author.replace(/^\w/, function(c) {
                      return c.toUpperCase();
                    });
                  },
                  count: Number,
                  valid: Boolean
                },
                stringify: {
                  author: function(author) {
                    return author.replace(/^\w/, function(c) {
                      return c.toLowerCase();
                    });
                  },
                  unknown: function(_) {
                    return "x";
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  var state = {
    routes: [
      {
        name: "Foo",
        state: {
          routes: [
            {
              name: "Foe",
              state: {
                routes: [
                  {
                    name: "Baz",
                    params: {
                      answer: "42",
                      author: "Jane",
                      count: 10,
                      valid: true
                    }
                  }
                ]
              }
            }
          ]
        }
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state, config)).toBe(path);
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path, config), config)).toBe(path);
});
(0, import_vitest.test)("handles state with config with nested screens and unused configs with exact", function() {
  var path = "/foe/baz/jane?answer=42&count=10&valid=true";
  var config = {
    screens: {
      Foo: {
        path: "foo",
        screens: {
          Foe: {
            path: "foe",
            exact: true,
            screens: {
              Baz: {
                path: "baz/:author",
                parse: {
                  author: function(author) {
                    return author.replace(/^\w/, function(c) {
                      return c.toUpperCase();
                    });
                  },
                  count: Number,
                  valid: Boolean
                },
                stringify: {
                  author: function(author) {
                    return author.replace(/^\w/, function(c) {
                      return c.toLowerCase();
                    });
                  },
                  unknown: function(_) {
                    return "x";
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  var state = {
    routes: [
      {
        name: "Foo",
        state: {
          routes: [
            {
              name: "Foe",
              state: {
                routes: [
                  {
                    name: "Baz",
                    params: {
                      answer: "42",
                      author: "Jane",
                      count: 10,
                      valid: true
                    }
                  }
                ]
              }
            }
          ]
        }
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state, config)).toBe(path);
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path, config), config)).toBe(path);
});
(0, import_vitest.test)("handles nested object with stringify in it", function() {
  var path = "/bar/sweet/apple/foo/bis/jane?answer=42&count=10&valid=true";
  var config = {
    screens: {
      Bar: {
        path: "bar/:type/:fruit",
        screens: {
          Foo: {
            path: "foo",
            screens: {
              Foe: {
                path: "foe"
              },
              Baz: {
                screens: {
                  Bos: "bos",
                  Bis: {
                    path: "bis/:author",
                    stringify: {
                      author: function(author) {
                        return author.replace(/^\w/, function(c) {
                          return c.toLowerCase();
                        });
                      }
                    },
                    parse: {
                      author: function(author) {
                        return author.replace(/^\w/, function(c) {
                          return c.toUpperCase();
                        });
                      },
                      count: Number,
                      valid: Boolean
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  var state = {
    routes: [
      {
        name: "Bar",
        params: {
          fruit: "apple",
          type: "sweet"
        },
        state: {
          routes: [
            {
              name: "Foo",
              state: {
                routes: [
                  {
                    name: "Baz",
                    state: {
                      routes: [
                        {
                          name: "Bis",
                          params: {
                            answer: "42",
                            author: "Jane",
                            count: 10,
                            valid: true
                          }
                        }
                      ]
                    }
                  }
                ]
              }
            }
          ]
        }
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state, config)).toBe(path);
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path, config), config)).toBe(path);
});
(0, import_vitest.test)("handles nested object with stringify in it with exact", function() {
  var path = "/bis/jane?answer=42&count=10&valid=true";
  var config = {
    screens: {
      Bar: {
        path: "bar/:type/:fruit",
        screens: {
          Foo: {
            path: "foo",
            screens: {
              Foe: {
                path: "foe"
              },
              Baz: {
                path: "baz",
                screens: {
                  Bos: "bos",
                  Bis: {
                    path: "bis/:author",
                    exact: true,
                    stringify: {
                      author: function(author) {
                        return author.replace(/^\w/, function(c) {
                          return c.toLowerCase();
                        });
                      }
                    },
                    parse: {
                      author: function(author) {
                        return author.replace(/^\w/, function(c) {
                          return c.toUpperCase();
                        });
                      },
                      count: Number,
                      valid: Boolean
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  var state = {
    routes: [
      {
        name: "Bar",
        params: {
          fruit: "apple",
          type: "sweet"
        },
        state: {
          routes: [
            {
              name: "Foo",
              state: {
                routes: [
                  {
                    name: "Baz",
                    state: {
                      routes: [
                        {
                          name: "Bis",
                          params: {
                            answer: "42",
                            author: "Jane",
                            count: 10,
                            valid: true
                          }
                        }
                      ]
                    }
                  }
                ]
              }
            }
          ]
        }
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state, config)).toBe(path);
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path, config), config)).toBe(path);
});
(0, import_vitest.test)("handles nested object for second route depth", function() {
  var path = "/foo/bar/baz";
  var config = {
    screens: {
      Foo: {
        path: "foo",
        screens: {
          Foe: "foe",
          Bar: {
            path: "bar",
            screens: {
              Baz: "baz"
            }
          }
        }
      }
    }
  };
  var state = {
    routes: [
      {
        name: "Foo",
        state: {
          routes: [
            {
              name: "Bar",
              state: {
                routes: [
                  {
                    name: "Baz"
                  }
                ]
              }
            }
          ]
        }
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state, config)).toBe(path);
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path, config), config)).toBe(path);
});
(0, import_vitest.test)("handles nested object for second route depth with exact", function() {
  var path = "/baz";
  var config = {
    screens: {
      Foo: {
        path: "foo",
        screens: {
          Foe: "foe",
          Bar: {
            path: "bar",
            screens: {
              Baz: {
                path: "baz",
                exact: true
              }
            }
          }
        }
      }
    }
  };
  var state = {
    routes: [
      {
        name: "Foo",
        state: {
          routes: [
            {
              name: "Bar",
              state: {
                routes: [
                  {
                    name: "Baz"
                  }
                ]
              }
            }
          ]
        }
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state, config)).toBe(path);
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path, config), config)).toBe(path);
});
(0, import_vitest.test)("handles nested object for second route depth and path and stringify in roots", function() {
  var path = "/foo/dathomir/bar/42/baz";
  var config = {
    screens: {
      Foo: {
        path: "foo/:planet",
        stringify: {
          id: function(id) {
            return `planet=${id}`;
          }
        },
        screens: {
          Foe: "foe",
          Bar: {
            path: "bar/:id",
            parse: {
              id: Number
            },
            screens: {
              Baz: "baz"
            }
          }
        }
      }
    }
  };
  var state = {
    routes: [
      {
        name: "Foo",
        params: {
          planet: "dathomir"
        },
        state: {
          routes: [
            {
              name: "Bar",
              state: {
                routes: [
                  {
                    name: "Baz",
                    params: {
                      id: 42
                    }
                  }
                ]
              }
            }
          ]
        }
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state, config)).toBe(path);
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path, config), config)).toBe(path);
});
(0, import_vitest.test)("handles nested object for second route depth and path and stringify in roots with exact", function() {
  var path = "/baz";
  var config = {
    screens: {
      Foo: {
        path: "foo/:id",
        stringify: {
          id: function(id) {
            return `id=${id}`;
          }
        },
        screens: {
          Foe: "foe",
          Bar: {
            path: "bar/:id",
            stringify: {
              id: function(id) {
                return `id=${id}`;
              }
            },
            parse: {
              id: Number
            },
            screens: {
              Baz: {
                path: "baz",
                exact: true
              }
            }
          }
        }
      }
    }
  };
  var state = {
    routes: [
      {
        name: "Foo",
        state: {
          routes: [
            {
              name: "Bar",
              state: {
                routes: [
                  {
                    name: "Baz"
                  }
                ]
              }
            }
          ]
        }
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state, config)).toBe(path);
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path, config), config)).toBe(path);
});
(0, import_vitest.test)("ignores empty string paths", function() {
  var path = "/bar";
  var config = {
    screens: {
      Foo: {
        path: "",
        screens: {
          Foe: "foe"
        }
      },
      Bar: "bar"
    }
  };
  var state = {
    routes: [
      {
        name: "Foo",
        state: {
          routes: [
            {
              name: "Bar"
            }
          ]
        }
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state, config)).toBe(path);
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path, config), config)).toBe(path);
});
(0, import_vitest.test)("keeps query params if path is empty", function() {
  var path = "/?foo=42";
  var config = {
    screens: {
      Foo: {
        screens: {
          Foe: "foe",
          Bar: {
            screens: {
              Qux: {
                path: "",
                parse: {
                  foo: Number
                }
              },
              Baz: "baz"
            }
          }
        }
      }
    }
  };
  var state = {
    routes: [
      {
        name: "Foo",
        state: {
          routes: [
            {
              name: "Bar",
              state: {
                routes: [
                  {
                    name: "Qux",
                    params: {
                      foo: 42
                    }
                  }
                ]
              }
            }
          ]
        }
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state, config)).toBe(path);
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path, config), config)).toEqual(path);
});
(0, import_vitest.test)("does not use Object.prototype properties as parsing functions", function() {
  var path = "/?toString=42";
  var config = {
    screens: {
      Foo: {
        screens: {
          Foe: "foe",
          Bar: {
            screens: {
              Qux: {
                path: "",
                parse: {}
              },
              Baz: "baz"
            }
          }
        }
      }
    }
  };
  var state = {
    routes: [
      {
        name: "Foo",
        state: {
          routes: [
            {
              name: "Bar",
              state: {
                routes: [
                  {
                    name: "Qux",
                    params: {
                      toString: 42
                    }
                  }
                ]
              }
            }
          ]
        }
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state, config)).toBe(path);
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path, config), config)).toEqual(path);
});
(0, import_vitest.test)("cuts nested configs too", function() {
  var path = "/foo/baz";
  var config = {
    screens: {
      Foo: {
        path: "foo",
        screens: {
          Bar: {
            path: "",
            screens: {
              Baz: {
                path: "baz"
              }
            }
          }
        }
      }
    }
  };
  var state = {
    routes: [
      {
        name: "Foo",
        state: {
          routes: [
            {
              name: "Bar",
              state: {
                routes: [
                  {
                    name: "Baz"
                  }
                ]
              }
            }
          ]
        }
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state, config)).toBe(path);
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path, config), config)).toBe(path);
});
(0, import_vitest.test)("cuts nested configs too with exact", function() {
  var path = "/baz";
  var config = {
    screens: {
      Foo: {
        path: "foo",
        screens: {
          Bar: {
            path: "",
            exact: true,
            screens: {
              Baz: {
                path: "baz"
              }
            }
          }
        }
      }
    }
  };
  var state = {
    routes: [
      {
        name: "Foo",
        state: {
          routes: [
            {
              name: "Bar",
              state: {
                routes: [
                  {
                    name: "Baz"
                  }
                ]
              }
            }
          ]
        }
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state, config)).toBe(path);
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path, config), config)).toBe(path);
});
(0, import_vitest.test)("handles empty path at the end", function() {
  var path = "/foo/bar";
  var config = {
    screens: {
      Foo: {
        path: "foo",
        screens: {
          Bar: "bar"
        }
      },
      Baz: {
        path: ""
      }
    }
  };
  var state = {
    routes: [
      {
        name: "Foo",
        state: {
          routes: [
            {
              name: "Bar",
              state: {
                routes: [
                  {
                    name: "Baz"
                  }
                ]
              }
            }
          ]
        }
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state, config)).toBe(path);
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path, config), config)).toBe(path);
});
(0, import_vitest.test)('returns "/" for empty path', function() {
  var path = "/";
  var config = {
    screens: {
      Foo: {
        path: "",
        screens: {
          Bar: ""
        }
      }
    }
  };
  var state = {
    routes: [
      {
        name: "Foo",
        state: {
          routes: [
            {
              name: "Bar"
            }
          ]
        }
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state, config)).toBe(path);
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path, config), config)).toBe(path);
});
(0, import_vitest.test)("parses no path specified", function() {
  var path = "/bar";
  var config = {
    screens: {
      Foo: {
        screens: {
          Foe: {},
          Bar: "bar"
        }
      }
    }
  };
  var state = {
    routes: [
      {
        name: "Foo",
        state: {
          routes: [
            {
              name: "Bar"
            }
          ]
        }
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state, config)).toBe(path);
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path, config), config)).toBe(path);
});
(0, import_vitest.test)("strips undefined query params", function() {
  var path = "/bar/sweet/apple/foo/bis/jane?count=10&valid=true";
  var config = {
    screens: {
      Bar: {
        path: "bar/:type/:fruit",
        screens: {
          Foo: {
            path: "foo",
            screens: {
              Foe: {
                path: "foe"
              },
              Baz: {
                screens: {
                  Bos: "bos",
                  Bis: {
                    path: "bis/:author",
                    stringify: {
                      author: function(author) {
                        return author.replace(/^\w/, function(c) {
                          return c.toLowerCase();
                        });
                      }
                    },
                    parse: {
                      author: function(author) {
                        return author.replace(/^\w/, function(c) {
                          return c.toUpperCase();
                        });
                      },
                      count: Number,
                      valid: Boolean
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  var state = {
    routes: [
      {
        name: "Bar",
        params: {
          fruit: "apple",
          type: "sweet"
        },
        state: {
          routes: [
            {
              name: "Foo",
              state: {
                routes: [
                  {
                    name: "Baz",
                    state: {
                      routes: [
                        {
                          name: "Bis",
                          params: {
                            author: "Jane",
                            count: 10,
                            valid: true
                          }
                        }
                      ]
                    }
                  }
                ]
              }
            }
          ]
        }
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state, config)).toBe(path);
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path, config), config)).toBe(path);
});
(0, import_vitest.test)("strips undefined query params with exact", function() {
  var path = "/bis/jane?count=10&valid=true";
  var config = {
    screens: {
      Bar: {
        path: "bar/:type/:fruit",
        screens: {
          Foo: {
            path: "foo",
            screens: {
              Foe: {
                path: "foe"
              },
              Baz: {
                screens: {
                  Bos: "bos",
                  Bis: {
                    path: "bis/:author",
                    exact: true,
                    stringify: {
                      author: function(author) {
                        return author.replace(/^\w/, function(c) {
                          return c.toLowerCase();
                        });
                      }
                    },
                    parse: {
                      author: function(author) {
                        return author.replace(/^\w/, function(c) {
                          return c.toUpperCase();
                        });
                      },
                      count: Number,
                      valid: Boolean
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  var state = {
    routes: [
      {
        name: "Bar",
        params: {
          fruit: "apple",
          type: "sweet"
        },
        state: {
          routes: [
            {
              name: "Foo",
              state: {
                routes: [
                  {
                    name: "Baz",
                    state: {
                      routes: [
                        {
                          name: "Bis",
                          params: {
                            author: "Jane",
                            count: 10,
                            valid: true
                          }
                        }
                      ]
                    }
                  }
                ]
              }
            }
          ]
        }
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state, config)).toBe(path);
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path, config), config)).toBe(path);
});
(0, import_vitest.test)("handles stripping all query params", function() {
  var path = "/bar/sweet/apple/foo/bis/jane";
  var config = {
    screens: {
      Bar: {
        path: "bar/:type/:fruit",
        screens: {
          Foo: {
            path: "foo",
            screens: {
              Foe: {
                path: "foe"
              },
              Baz: {
                screens: {
                  Bos: "bos",
                  Bis: {
                    path: "bis/:author",
                    stringify: {
                      author: function(author) {
                        return author.replace(/^\w/, function(c) {
                          return c.toLowerCase();
                        });
                      }
                    },
                    parse: {
                      author: function(author) {
                        return author.replace(/^\w/, function(c) {
                          return c.toUpperCase();
                        });
                      },
                      count: Number,
                      valid: Boolean
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  var state = {
    routes: [
      {
        name: "Bar",
        params: {
          fruit: "apple",
          type: "sweet"
        },
        state: {
          routes: [
            {
              name: "Foo",
              state: {
                routes: [
                  {
                    name: "Baz",
                    state: {
                      routes: [
                        {
                          name: "Bis",
                          params: {
                            author: "Jane"
                          }
                        }
                      ]
                    }
                  }
                ]
              }
            }
          ]
        }
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state, config)).toBe(path);
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path, config), config)).toBe(path);
});
(0, import_vitest.test)("handles stripping all query params with exact", function() {
  var path = "/bis/jane";
  var config = {
    screens: {
      Bar: {
        path: "bar/:type/:fruit",
        screens: {
          Foo: {
            path: "foo",
            screens: {
              Foe: {
                path: "foe"
              },
              Baz: {
                path: "baz",
                screens: {
                  Bos: "bos",
                  Bis: {
                    path: "bis/:author",
                    exact: true,
                    stringify: {
                      author: function(author) {
                        return author.replace(/^\w/, function(c) {
                          return c.toLowerCase();
                        });
                      }
                    },
                    parse: {
                      author: function(author) {
                        return author.replace(/^\w/, function(c) {
                          return c.toUpperCase();
                        });
                      },
                      count: Number,
                      valid: Boolean
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  var state = {
    routes: [
      {
        name: "Bar",
        params: {
          fruit: "apple",
          type: "sweet"
        },
        state: {
          routes: [
            {
              name: "Foo",
              state: {
                routes: [
                  {
                    name: "Baz",
                    state: {
                      routes: [
                        {
                          name: "Bis",
                          params: {
                            author: "Jane"
                          }
                        }
                      ]
                    }
                  }
                ]
              }
            }
          ]
        }
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state, config)).toBe(path);
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path, config), config)).toBe(path);
});
(0, import_vitest.test)("replaces undefined query params", function() {
  var path = "/bar/undefined/apple";
  var config = {
    screens: {
      Bar: "bar/:type/:fruit"
    }
  };
  var state = {
    routes: [
      {
        name: "Bar",
        params: {
          fruit: "apple"
        }
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state, config)).toBe(path);
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path, config), config)).toBe(path);
});
import_vitest.test.skip("matches wildcard patterns at root", function() {
  var path = "/test/bar/42/whatever";
  var config = {
    screens: {
      404: "*",
      Foo: {
        screens: {
          Bar: {
            path: "/bar/:id/"
          }
        }
      }
    }
  };
  var state = {
    routes: [
      {
        name: "404"
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state, config)).toBe("/404");
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path, config), config)).toBe("/404");
});
import_vitest.test.skip("matches wildcard patterns at nested level", function() {
  var path = "/bar/42/whatever/baz/initt";
  var config = {
    screens: {
      Foo: {
        screens: {
          Bar: {
            path: "/bar/:id/",
            screens: {
              404: "*"
            }
          }
        }
      }
    }
  };
  var state = {
    routes: [
      {
        name: "Foo",
        state: {
          routes: [
            {
              name: "Bar",
              params: {
                id: "42"
              },
              state: {
                routes: [
                  {
                    name: "404"
                  }
                ]
              }
            }
          ]
        }
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state, config)).toBe("/bar/42/404");
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path, config), config)).toBe("/bar/42/404");
});
import_vitest.test.skip("matches wildcard patterns at nested level with exact", function() {
  var path = "/whatever";
  var config = {
    screens: {
      Foo: {
        screens: {
          Bar: {
            path: "/bar/:id/",
            screens: {
              404: {
                path: "*",
                exact: true
              }
            }
          },
          Baz: {}
        }
      }
    }
  };
  var state = {
    routes: [
      {
        name: "Foo",
        state: {
          routes: [
            {
              name: "Bar",
              state: {
                routes: [
                  {
                    name: "404"
                  }
                ]
              }
            }
          ]
        }
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state, config)).toBe("/404");
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path, config), config)).toBe("/404");
});
(0, import_vitest.test)("tries to match wildcard patterns at the end", function() {
  var path = "/bar/42/test";
  var config = {
    screens: {
      Foo: {
        screens: {
          Bar: {
            path: "/bar/:id/",
            screens: {
              404: "*",
              Test: "test"
            }
          }
        }
      }
    }
  };
  var state = {
    routes: [
      {
        name: "Foo",
        state: {
          routes: [
            {
              name: "Bar",
              params: {
                id: "42"
              },
              state: {
                routes: [
                  {
                    name: "Test"
                  }
                ]
              }
            }
          ]
        }
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state, config)).toBe(path);
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path, config), config)).toBe(path);
});
import_vitest.test.skip("uses nearest parent wildcard match for unmatched paths", function() {
  var path = "/bar/42/baz/test";
  var config = {
    screens: {
      Foo: {
        screens: {
          Bar: {
            path: "/bar/:id/",
            screens: {
              Baz: "baz"
            }
          },
          404: "*"
        }
      }
    }
  };
  var state = {
    routes: [
      {
        name: "Foo",
        state: {
          routes: [
            {
              name: "404"
            }
          ]
        }
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state, config)).toBe("/404");
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path, config), config)).toBe("/404");
});
import_vitest.test.skip("handles path at top level", function() {
  var path = "foo/fruits/apple";
  var config = {
    path: "foo",
    screens: {
      Foo: {
        screens: {
          Fruits: "fruits/:fruit"
        }
      }
    }
  };
  var state = {
    routes: [
      {
        name: "Foo",
        state: {
          routes: [
            {
              name: "Fruits",
              params: {
                fruit: "apple"
              }
            }
          ]
        }
      }
    ]
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)(state, config)).toBe(`/${path}`);
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)((0, import_getStateFromPath.getStateFromPath)(path, config), config)).toBe(`/${path}`);
});
import_vitest.test.skip("ignores regexp patterns when provided", function() {
  var config = {
    screens: {
      Foo: {
        path: "foo/:id(\\d+)",
        parse: {
          id: Number
        }
      },
      Bar: {
        path: "foo/:id([a-z]+)"
      },
      Baz: {
        path: "foo/:id(\\d+)/:name([a-z]+)"
      },
      Qux: {
        path: "foo/:id(@[a-z]+)",
        stringify: {
          id: function(id) {
            return `@${id}`;
          }
        }
      }
    }
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)({
    routes: [
      {
        name: "Foo",
        params: {
          id: 42
        }
      }
    ]
  }, config)).toBe("/foo/42");
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)({
    routes: [
      {
        name: "Bar",
        params: {
          id: "bar"
        }
      }
    ]
  }, config)).toBe("/foo/bar");
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)({
    routes: [
      {
        name: "Baz",
        params: {
          id: 42,
          name: "bar"
        }
      }
    ]
  }, config)).toBe("/foo/42/bar");
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)({
    routes: [
      {
        name: "Qux",
        params: {
          id: "bar"
        }
      }
    ]
  }, config)).toBe("/foo/@bar");
});
import_vitest.test.skip("correctly handles regex pattern with slash", function() {
  var config = {
    screens: {
      Foo: {
        path: "foo/:id([a-z]+\\/)"
      }
    }
  };
  (0, import_vitest.expect)((0, import_getPathFromState.getPathFromState)({
    routes: [
      {
        name: "Foo",
        params: {
          id: "bar"
        }
      }
    ]
  }, config)).toBe("/foo/bar");
});
//# sourceMappingURL=getPathFromState.test.js.map
